import styled, { css } from "styled-components";

const smallMixin = css`
  margin: 0 0 0 2em;
`;
const desktopMixin = css`
  max-width: none;
  margin: 0 0 0 16em;
`;

export const Container = styled.div`
  margin: 5em 2em 3em;
  ${({ size }) =>
    ["small", "medium", "desktop"].includes(size) ? smallMixin : ""}
  ${({ size }) => (["desktop"].includes(size) ? desktopMixin : "")}
`;
